import { RouterProvider } from "react-router-dom";

import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { CongressProvider } from "@/features/congress-select/components/congress-provider";
import { queryClient } from "@/libs/react-query";
import "@/libs/sentry";
import { QueryClientProvider } from "@tanstack/react-query";

import { router } from "../router";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="congressworks-theme">
        <CongressProvider>
          <RouterProvider router={router} />
          <Toaster />
        </CongressProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
